import type { ReactNode } from 'react'
import { FileText } from 'lucide-react'
import companyFormStyles from '../../styles/emailTemplateCard.module.css'

export function EmailTemplateFormSection({
  testId,
  title,
  children,
  icon: Icon,
}: {
  testId?: string
  title: ReactNode
  children: ReactNode
  icon?: React.ElementType
}) {
  const IconComponent = Icon || FileText
  return (
    <div data-testid={testId} className={companyFormStyles.card}>
      <div className={companyFormStyles.cardHeader}>
        <IconComponent className={companyFormStyles.cardIcon} />
        <h3 className={companyFormStyles.cardTitle}>{title}</h3>
      </div>
      <div className={companyFormStyles.cardBody}>{children}</div>
    </div>
  )
}
